module.exports = __webpack_public_path__ + "media/educator_advisory_board/David_Levy-a8761b5c.png";